const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const TRANSIENT_HTTP_STATUSES = new Set([408, 429, 502, 503, 504]);

const isRetryableError = (error) => {
    if (typeof error?.data?.retryable === 'boolean') return error.data.retryable;
    return TRANSIENT_HTTP_STATUSES.has(Number(error?.status));
};

export const getRetryDelayMs = (error, fallbackMs, maxDelayMs) => {
    const retryAfterMs = Number(error?.data?.retryAfterMs);
    return Number.isFinite(retryAfterMs) && retryAfterMs > 0 ? Math.min(retryAfterMs, maxDelayMs) : fallbackMs;
};

export const withRetry = async (
    operation,
    { baseDelayMs = 500, jitterMs = 250, maxDelayMs = 15_000, retries = 2 } = {}
) => {
    for (let attempt = 0; attempt <= retries; attempt += 1) {
        try {
            return await operation();
        } catch (error) {
            if (attempt === retries || !isRetryableError(error)) throw error;

            const fallbackDelay =
                Math.min(baseDelayMs * Math.pow(2, attempt), maxDelayMs) + Math.floor(Math.random() * jitterMs);
            const delay = getRetryDelayMs(error, fallbackDelay, maxDelayMs);
            await sleep(delay);
        }
    }
};
